import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import styles from "../SchedaSpecialeArbovirosi.module.css";
import Utils from "../../../../../../../utils/Utils";

// Mappa malattia → codici InfoLaboratorio
const virusCodes = {
    "Toscana Virus": ["347", "348", "344", "345", "346", "341", "342", "343", "332", "349"],
    "Usutu":         ["338", "336", "337", "335", "333", "334", "339", "331", "340"],
    "Bunyavirus":    ["322", "323", "159", "156"],
    "Togavirus":     ["326", "327", "157", "154"],
    "Flavivirus":    ["324", "325", "158", "155"],
    "Encefalite Virale trasmessa da Artropodi": ["350"]
};

// Mappa malattia → valore radio button
const malattiaToRadioValue = {
    "Toscana Virus": "TOSCANA_VIRUS",
    "Usutu":         "62",
    "Bunyavirus":    "BUNYAVIRUS",
    "Togavirus":     "TOGAVIRUS",
    "Flavivirus":    "FLAVIVIRUS",
    "Encefalite virale da zecche": "064"
};

class Segnalazioni extends Component {
    state = {
        Malattia: {
            malattiaSelezionata: this.props.malattia || "",
            disabled: !!this.props.malattia,
            corretto: []
        }
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.calcolaMalattiaDA064 = this.calcolaMalattiaDA064.bind(this);
    }

    componentDidMount() {
        console.log("[Segnalazioni] componentDidMount");
        console.log("[Segnalazioni] malattia prop:", this.props.malattia);
        console.log("[Segnalazioni] segnalazioneCopia:", this.props.segnalazioneCopia);

        if (this.props.malattia === "064" && this.props.segnalazioneCopia) {
            console.log("[Segnalazioni] condizione malattia=064 soddisfatta, avvio risoluzione");
            const valore = this.calcolaMalattiaDA064();
            console.log("[Segnalazioni] valore radio risolto:", valore);
            if (valore) {
                this.setState(prevState => ({
                    Malattia: {
                        ...prevState.Malattia,
                        malattiaSelezionata: valore,
                        disabled: true
                    }
                }), () => this.aggiornaPadre());
                return;
            } else {
                console.warn("[Segnalazioni] nessun valore trovato per malattia=064");
            }
        } else {
            console.log("[Segnalazioni] condizione 064 non soddisfatta — malattia:", this.props.malattia, "| segnalazioneCopia present:", !!this.props.segnalazioneCopia);
        }
        this.aggiornaPadre();
    }

    calcolaMalattiaDA064() {
        const seg = this.props.segnalazioneCopia;

        // listaDettaglioLab può essere al top-level o dentro infoLaboratorio
        const listaRaw =
            seg?.listaDettaglioLab ??
            seg?.infoLaboratorio?.listaDettaglioLab;

        console.log("[Segnalazioni] listaDettaglioLab trovata:", listaRaw);

        if (!listaRaw) {
            console.warn("[Segnalazioni] listaDettaglioLab non trovata in segnalazioneCopia");
            return null;
        }

        const lista = Array.isArray(listaRaw) ? listaRaw : [listaRaw];
        console.log("[Segnalazioni] lista normalizzata:", lista);

        for (const item of lista) {
            // L'item può essere una stringa diretta oppure un oggetto con codiceInfoLaboratorio
            const codice = String(item?.codiceInfoLaboratorio ?? item ?? "").trim();
            console.log("[Segnalazioni] analisi item:", item, "→ codice estratto:", codice);

            for (const [malattia, codici] of Object.entries(virusCodes)) {
                if (codici.includes(codice)) {
                    const radioValue = malattiaToRadioValue[malattia];
                    console.log("[Segnalazioni] codice", codice, "→ malattia:", malattia, "→ radio value:", radioValue);
                    return radioValue;
                }
            }
            console.warn("[Segnalazioni] codice", codice, "non trovato in nessuna malattia di virusCodes");
        }
        return null;
    }

    riceviValore(field, value) {
        this.setState(
            prevState => ({
                Malattia: { ...prevState.Malattia, [field]: value }
            }),
            () => this.aggiornaPadre()
        );
    }

    controlloCorrettezza() {
        let dati = this.state.Malattia;
        dati.corretto = [];
        if (!dati.malattiaSelezionata) {
            dati.corretto[0] = "Selezionare una malattia";
        }
    }

    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.Malattia));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    aggiornaPadre() {
        this.controlloCorrettezza();
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();
        let oggettoBE = this.createOggettoBE();
        if (this.props.setMalattia) {
            this.props.setMalattia(this.state.Malattia, Utils.removeFieldFromObject(oggettoBE, "disabled"));
        }
    }

    render() {
        const { t } = this.props;
        const data = this.state.Malattia;
        const path = "SchedaSpecialeArbovirosi.Segnalazioni";

        const patologie = [
            { id: "westNile",     label: "Febbre virale West Nile",                     value: "0664"          },
            { id: "chikungunya",  label: "Chikungunya",                                 value: "0663CH"        },
            { id: "dengue",       label: "Dengue",                                      value: "061"           },
            { id: "zika",         label: "Zika",                                        value: "0663ZI"        },
            { id: "tbe",          label: "Encefalite virale da zecche",                 value: "063"           },
            { id: "altraZecche",  label: "Altra malattia virale da zecche",             value: "0669"          },
            { id: "artropodi",    label: "Encefalite virale trasmessa da artropodi",    value: "064"           },
            { id: "toscanaVirus", label: "Toscana Virus",                               value: "TOSCANA_VIRUS" },
            { id: "usutu",        label: "Usutu",                                       value: "62"            },
            { id: "bunyavirus",   label: "Bunyavirus",                                  value: "BUNYAVIRUS"    },
            { id: "togavirus",    label: "Togavirus",                                   value: "TOGAVIRUS"     },
            { id: "flavivirus",   label: "Flavivirus",                                  value: "FLAVIVIRUS"    }
        ];

        return (
            <div className={styles.container_fluid_arbovirosi} style={{ marginTop: "20px" }}>
                <div className="row align-items-start">
                    <div className="col-lg-2">
                        <p style={{ fontWeight: "bold", fontSize: "16px", marginTop: "5px" }}>
                            {t(`${path}.titolo`, "Segnalazione di:")}
                        </p>
                    </div>
                    <div className="col-lg-10">
                        <div className={`row ${styles.radioBluDisabled}`}>
                            {patologie.map(p => (
                                <div key={p.id} className="col-lg-3 mb-3">
                                    <RadioButton
                                        id={p.id}
                                        name="malattiaSelezionata"
                                        label={t(`${path}.${p.id}`, p.label)}
                                        value={p.value}
                                        field="malattiaSelezionata"
                                        checked={data.malattiaSelezionata === p.value}
                                        onClick={() => this.riceviValore("malattiaSelezionata", p.value)}
                                        newRadio={true}
                                        style={{ color: "black", fontSize: "16px" }}
                                        disabled={true}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(Segnalazioni);
